<script>
import { mapActions } from 'pinia'
import { useAuthStore } from '@/stores/auth.js'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card/index.js'
import { Input } from '@/components/ui/input/index.js'
import { Button } from '@/components/ui/button/index.js'
import { Label } from '@/components/ui/label/index.js'
import { toast } from 'vue-sonner'

export default {
  components: { Label, Button, CardFooter, Input, CardContent, CardDescription, CardTitle, CardHeader, Card },
  data: () => {
    return {
      errors: null,
      loading: null,
      email: null,
      password: null,
      remember: null
    }
  },
  methods: {
    ...mapActions(useAuthStore, ['attempt_user', 'set_user', 'login']),
    getLoginErrorMessage (error) {
      const responseData = error.response?.data
      const responseMessage = responseData?.message

      if (typeof responseMessage === 'string' && responseMessage.trim()) {
        return responseMessage
      }

      const validationMessages = Object.values(responseData?.errors || {})
        .flat()
        .filter((message) => typeof message === 'string' && message.trim())

      return validationMessages[0] || this.$t('login.login_error')
    },
    async loginSubmit () {
      try {
        this.errors = null
        this.loading = true
        await this.login({
          email: this.email,
          password: this.password,
          remember: this.remember
        })
        this.errors = false
      } catch (e) {
        console.error(e)
        this.loading = false
        if (e.response) this.errors = e.response.data
        toast.error(this.getLoginErrorMessage(e))
      }
    }
  }
}
</script>

<template>
  <form @submit.prevent="loginSubmit">
    <Card class="w-full max-w-sm">
      <CardHeader>
        <CardTitle class="text-2xl">
          {{ $t('login.header') }}
        </CardTitle>
        <CardDescription>
          {{ $t('login.subheader') }}
        </CardDescription>
      </CardHeader>

      <CardContent class="grid gap-4">
        <div class="grid gap-2">
          <Label for="email">{{ $t('login.email') }}</Label>
          <Input
            id="email"
            v-model="email"
            type="email"
            placeholder="m@example.com"
            required
          />
        </div>
        <div class="grid gap-2">
          <div class="flex items-center justify-between gap-2">
            <Label for="password">{{ $t('login.password') }}</Label>
            <router-link :to="{ name: 'ForgotPassword' }" class="text-sm text-muted-foreground underline hover:text-foreground">
              {{ $t('login.forgot_password') }}
            </router-link>
          </div>
          <Input
            id="password"
            v-model="password"
            type="password"
            required
          />
        </div>
      </CardContent>

      <CardFooter>
        <Button block :loading="loading" type="submit">
          {{ $t('login.login_button') }}
          <template #loading>
            {{ $t('login.login_button_loading') }}
          </template>
        </Button>
      </CardFooter>
    </Card>
  </form>
</template>
